// AOS Library
import AOS from 'aos';
import 'aos/dist/aos.css';

// ****************************************************************************************************************************************************
// Utility to adjust lineup button layout based on container width

export function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const lineup = $(element);
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    if (icons.width() + buttons.width() > containerSize - 20) {
      buttonContainer.addClass('column');
    }

    if (!icons.children().length) {
      icons.remove();
    }
  });
}

// ****************************************************************************************************************************************************
// Function to customize search button

export function customizeSearch() {
  $('.header .searchSubmitButton').attr('tabindex', '-1');

  const input = $('.header .inputFieldTextbox');
  const defaultText = 'Search Website';

  input.on('focus', function () {
    if ($(this).val() === defaultText) {
      $(this).val('');
    }
  });

  input.on('blur', function () {
    if ($(this).val().trim() === '') {
      $(this).val(defaultText);
    }
  });
}

// ****************************************************************************************************************************************************
// Function to calculate content margin top

export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 1100px)');
    const additionalValue = mq.matches ? 20 : 70;

    const content = $('.content');
    const isHomepage = $('body').hasClass('homepage');

    content.css(
      'margin-top',
      isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
    );
  }

  applyMargin();

  $(globalThis).on('resize', applyMargin);

  $(globalThis).on('scroll', function () {
    if ($(this).scrollTop() === 0) {
      setTimeout(applyMargin, 300);
    }
  });

  new ResizeObserver(applyMargin).observe(document.querySelector('.header'));
}

// ****************************************************************************************************************************************************
// Function to check if the viewport width meets or exceeds a breakpoint.

export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

// ****************************************************************************************************************************************************
// Function to apply AOS animation

export function aosAnimation(element, animation) {
  if (element.length) {
    element.attr('data-aos', animation);

    AOS.init({
      once: false,
      duration: 800,
    });
  }
}
